/* SVELIA — fiche produit : la taille de chaque legging doit être choisie par la cliente (09/10/2026).
   Pumper présélectionne la première taille (S) : on l'affiche « à choisir » et on bloque l'ajout tant qu'elle n'a pas cliqué. */
(function () {
  if (window.__svTaille) return;
  window.__svTaille = true;

  var css = [
    '.sv-apps .sv-size-pending .pumper_swatch_grid--text .pumper_swatch_selected{background:#fff!important;border-color:rgba(35,27,23,.22)!important;color:#231B17!important;box-shadow:none!important}',
    '.sv-apps .sv-size-pending .pumper_swatch_label strong{display:none!important}',
    '.sv-apps .sv-size-pending .pumper_swatch_label::after{content:"à choisir";letter-spacing:.06em;text-transform:none;font-size:12px;color:#231B17}',
    'html[lang^="en"] .sv-apps .sv-size-pending .pumper_swatch_label::after{content:"please choose"}',
    '.sv-apps .sv-size-error{outline:1.5px solid #9B3B2E;outline-offset:6px;border-radius:12px}',
    '.sv-apps .sv-size-error .pumper_swatch_label::after{color:#9B3B2E;font-weight:600}',
    '.sv-apps .sv-size-pending .pumper_dropdown_trigger .pumper_dropdown_value{font-size:0!important}',
    '.sv-apps .sv-size-pending .pumper_dropdown_trigger .pumper_dropdown_value::after{content:"à choisir";font-size:13px}',
    'html[lang^="en"] .sv-apps .sv-size-pending .pumper_dropdown_trigger .pumper_dropdown_value::after{content:"Pick a size";text-transform:none}',
    '.sv-apps .sv-size-error .pumper_dropdown_value::after{color:#9B3B2E;font-weight:600}'
  ].join('\n');

  function init() {
    var apps = document.querySelector('.sv-apps');
    if (!apps) return;
    var st = document.createElement('style');
    st.textContent = css;
    document.head.appendChild(st);

    var pdp = apps.closest('[data-sv-pdp]') || document;
    var picked = {};

    function tier() {
      var r = apps.querySelector('input[type=radio]:checked');
      return r ? r.value : '0';
    }
    // Groupes de taille visibles : boutons (version française) ou menu déroulant (version anglaise)
    function groups() {
      var btns = [].map.call(apps.querySelectorAll('.pumper_swatch_grid--text'), function (g) { return g.closest('.pumper_swatch_group') || g.parentNode; });
      var drops = [].filter.call(apps.querySelectorAll('.pumper_dropdown_group'), function (d) {
        var t = d.querySelector('.pumper_dropdown_trigger');
        return t && /^\s*(size|taille)\b/i.test(t.getAttribute('aria-label') || '');
      });
      return btns.concat(drops).filter(function (g) { return g.offsetParent !== null; });
    }
    function key(g, list) { return tier() + ':' + (list || groups()).indexOf(g); }
    function mark() {
      var list = groups();
      list.forEach(function (g) {
        var ok = !!picked[key(g, list)];
        if (g.classList.contains('sv-size-pending') === ok) g.classList.toggle('sv-size-pending', !ok);
        if (ok && g.classList.contains('sv-size-error')) g.classList.remove('sv-size-error');
      });
    }

    // Un clic sur une taille = choix explicite pour ce legging
    apps.addEventListener('click', function (e) {
      var b = e.target.closest('.pumper_swatch_btn, .pumper_dropdown_option');
      var g = b && b.closest('.pumper_swatch_group, .pumper_dropdown_group');
      var list = groups();
      if (!g || list.indexOf(g) === -1) return;
      picked[key(g, list)] = true;
      setTimeout(mark, 0);
    }, true);
    apps.addEventListener('change', function () { setTimeout(mark, 120); });
    new MutationObserver(mark).observe(apps, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    mark();

    // Ajout au panier : on montre les tailles manquantes au lieu d'ajouter du S par défaut
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('button[name="add"]');
      if (!btn || !pdp.contains(btn)) return;
      var list = groups();
      var pend = list.filter(function (g) { return !picked[key(g, list)]; });
      if (!pend.length) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      pend.forEach(function (g) { g.classList.add('sv-size-error'); });
      pend[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, true);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
